export default "__VITE_ASSET__BWMjjeLr__"